import React, { FunctionComponent } from 'react';
import { AnyServerError } from 'src/hooks/use-api-error';
import Translate from 'ui/atoms/translate';
import makeForm from 'ui/forms';
import { handleError } from 'src/ui/helper/error-handling';
import useTranslate from 'src/ui/hooks/use-translate';

export interface EnterNewEmailProps {
  receiverEmail: string;
  onSubmit: (values: EnterNewEmailFields) => void;
  error?: AnyServerError;
}

export interface EnterNewEmailFields {
  email: string;
}

const EnterNewEmailForm = makeForm<EnterNewEmailFields>();

const EnterNewEmail: FunctionComponent<EnterNewEmailProps> = (props) => {
  const { receiverEmail, onSubmit = () => {}, error } = props;

  const { getErrorForField: getUniqueEmailError } = handleError({
    error,
    translate: useTranslate(),
    specialCodes: {
      email_already_used: {
        field: 'email',
        translateKey: 'errors.emailAlreadyUsed',
      },
    },
  });

  return (
    <>
      <p>
        <Translate name="investmentEnterNewEmail.enterNewEmailAddress" />
      </p>
      <EnterNewEmailForm
        onSubmit={onSubmit}
        initial={{ email: receiverEmail }}
        i18nKey="investmentEnterNewEmail"
        error={error}
      >
        <EnterNewEmailForm.Group required={true} name="email" fieldError={getUniqueEmailError('email')}>
          <EnterNewEmailForm.Input />
          {EnterNewEmailForm.Validators.Email()}
        </EnterNewEmailForm.Group>
        <EnterNewEmailForm.Submit size="large" fluid={true} variant="primary">
          <Translate name="investmentConfirmEmail.resendEmail" />
        </EnterNewEmailForm.Submit>
      </EnterNewEmailForm>
    </>
  );
};

export default EnterNewEmail;
